'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoQuote = function IoQuote(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 5c-3.2 0-5.7 0.9-7.4 2.6s-2.6 4.2-2.6 7.4v20h12.5v-20h-7.5c0-1.8 0.4-3 1.2-3.8s2-1.2 3.8-1.2z m17.5 0c-3.2 0-5.7 0.9-7.4 2.6s-2.6 4.2-2.6 7.4v20h12.5v-20h-7.5c0-1.8 0.4-3 1.2-3.8s2-1.2 3.8-1.2z' })
        )
    );
};

exports.default = IoQuote;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/quote.js
// module id = 2631
// module chunks = 0